import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Alert } from 'reactstrap';
import LoginPage from './containers/SignIn';
import Header from './containers/Header';
import Footer from './containers/Footer';
import Main from './Main';
import ScrollToTop from './components/ScrollToTop';
import useWidth from 'hooks/useWidth';

import './App.css';

const App = () => {
  const { down } = useWidth();
  const mobile = down('lg');
  const {
    app: { appDataInProgress, appDataError },
    auth: { initialCheckInProgress, isAuthorized: isLoggedIn, defaultPassword }
  } = useSelector(state => state);

  useEffect(() => {
    let className = '';
    className = mobile ? 'is_mobile' : 'is_desktop';
    if (!isLoggedIn && !initialCheckInProgress) {
      className += ' logout';
    }
    document.body.className = className;
  }, [mobile, isLoggedIn, initialCheckInProgress]);

  if (appDataInProgress || initialCheckInProgress) return null;

  if (!!appDataError) {
    return (
      <div>
        <Alert color='danger'>{appDataError}</Alert>
      </div>
    );
  }

  return (
    <ScrollToTop>
      <div id='lkk' className='d-flex flex-column bg-light'>
        <Header />
        <section id='lkk_content' style={{ flex: '1 1 auto' }}>
          {isLoggedIn ? <Main defaultPassword={defaultPassword} /> : <LoginPage />}{' '}
        </section>
        <Footer />
      </div>
    </ScrollToTop>
  );
};

export default withRouter(App);
